import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const UsefulLinksSection = () => {
    return (
        <Container>
            <HeaderDiv>
                <h3>Useful Links</h3>
            </HeaderDiv>
            <LinksContainer>
                <Link to="/">Home</Link>

                <Link to="/services">Services</Link>

                <Link to="/hardware">Hardware</Link>

                <Link to="/software">Software</Link>

                <Link to="/aboutus">About Us</Link>

                <Link to="/contactus">Contact Us</Link>
            </LinksContainer>
        </Container>
    )
}

export default UsefulLinksSection

const Container = styled.div`
    padding: 1rem 2rem;
    margin: 1rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    @media screen and (max-width:900px){
        padding: 1rem 0rem;
        margin: 0rem;
        /* text-align: center; */
    }
`

const HeaderDiv = styled.div`
    h3{
        color: #fff;
        display: inline-block;
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
        border-bottom: 0.1rem solid #4b5280;
    }
    @media screen and (max-width:900px){
        display: flex;
        align-items: center;
        justify-content: center;
        h3{
            margin-left: 0rem;
        }
    }
`

const LinksContainer = styled.div`
    display: flex;
    flex-direction: column;
    a{  
        text-decoration: none;
        color: white;
        padding: 0.2rem;
        font-size: 1.1rem;
        &:hover{
            color: #fff;
        }
    }
    @media screen and (max-width:900px){
        align-items: center;
        justify-content: center;
    }
`;